
import React from "react";
import { BarChart, Calendar, ChevronRight, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { 
  EnhancedCard as Card, 
  EnhancedCardContent as CardContent 
} from "@/components/ui/enhanced-card";

interface QuickActionsProps {
  staffId?: string;
}

const QuickActions: React.FC<QuickActionsProps> = ({ staffId }) => {
  const navigate = useNavigate();
  
  return (
    <div className="space-y-4">
      <h4 className="font-medium">Quick Actions</h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card 
          onClick={() => navigate("/app/dashboard")}
          variant="default"
          hoverEffect={true}
        >
          <CardContent className="p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-blue-500/10 flex items-center justify-center">
                <BarChart className="h-5 w-5 text-blue-500" />
              </div>
              <div>
                <h4 className="font-medium text-sm">Dashboard</h4>
                <p className="text-xs text-muted-foreground">View analytics and tasks</p>
              </div>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          </CardContent>
        </Card>
        
        <Card 
          onClick={() => navigate("/app/integrations")}
          variant="default"
          hoverEffect={true}
        >
          <CardContent className="p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-green-500/10 flex items-center justify-center">
                <Calendar className="h-5 w-5 text-green-500" />
              </div>
              <div>
                <h4 className="font-medium text-sm">Integrations</h4>
                <p className="text-xs text-muted-foreground">Connect your tools</p>
              </div>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          </CardContent>
        </Card>
        
        <Card 
          variant="default"
          hoverEffect={true}
          onClick={() => staffId && navigate(`/app/staff/${staffId}/training`)}
        >
          <CardContent className="p-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full bg-amber-500/10 flex items-center justify-center">
                <Star className="h-5 w-5 text-amber-500" />
              </div>
              <div>
                <h4 className="font-medium text-sm">Training</h4>
                <p className="text-xs text-muted-foreground">Improve your assistant</p>
              </div>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default QuickActions;
